import { DataTable, Dialog, FormFileInput, FormSectionHeader, FormTextarea, Loader } from "@/components"
import { FormProvider } from "react-hook-form"
import { DESCRIPTION, FILE, UPLOADED_FILES } from "./consts"
import useProjectDesignDoc from "./useProjectDesignDoc"
import { Button } from "@/components/ui"

const ProjectDesignDoc = () => {
  const {form, requiredFields, isView, attachmentRef, onSubmit, isAddAttachmentPending, isAttachmentLoading, showImageDialog,
    setShowImageDialog, columns, isDeleteAttachmentPending, isImageLoading, imageData, isImageRefetching} = useProjectDesignDoc();
  const {errors} = form.formState;

  return isAttachmentLoading ? <Loader /> : (
    <>
      <FormProvider {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)}>
          <div className="bg-white mt-[20px] rounded-lg shadow-sm overflow-hidden px-[30px] py-[25px]">
            <FormSectionHeader>Design Doc</FormSectionHeader>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-[30px]">
              <div>
                <FormFileInput
                  name={FILE}
                  fileInputRef={attachmentRef}
                  label="Attachment"
                  placeholder="Please select(max 5 MB)"
                  error={errors[FILE]?.message}
                  isRequired={requiredFields.includes(FILE)}
                  disabled={isView}
                  accept="image/*"
                  maxSize={5}
                />
              </div>
              <div className="col-span-2">
                <FormTextarea
                  name={DESCRIPTION}
                  control={form.control}
                  label="Description"
                  placeholder="Please enter"
                  error={errors[DESCRIPTION]?.message}
                  isRequired={requiredFields.includes(DESCRIPTION)}
                  disabled={isView}
                />
              </div>
            </div>
          </div>
          {!isView && (
                <div className="flex flex-row justify-end gap-3 py-5">
                  <Button
                    type="submit"
                    disabled={isAddAttachmentPending || isDeleteAttachmentPending}
                  >
                    {isAddAttachmentPending ? <Loader variant="secondary" /> : <></>}
                    Save
                  </Button>
                </div>
              )}
        </form>
      </FormProvider>
      <DataTable columns={columns} data={form.watch(UPLOADED_FILES) || []} />
      <Dialog 
        open={showImageDialog}
        setOpen={setShowImageDialog}
        title={
          <div className="text-2xl font-bold text-primary">
            {"View Image"}
          </div>
        }
        hideFooter
      >
        {isImageLoading || isImageRefetching ? <Loader /> : <img src={imageData?.data?.presignedUrl} />}
      </Dialog>
    </>
  )
}

export default ProjectDesignDoc;